import { render, staticRenderFns } from "./Esg3.vue?vue&type=template&id=ea92b872&scoped=true"
import script from "./Esg3.vue?vue&type=script&lang=js"
export * from "./Esg3.vue?vue&type=script&lang=js"
import style0 from "./Esg3.vue?vue&type=style&index=0&id=ea92b872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea92b872",
  null
  
)

export default component.exports